import {Component, Input} from '@angular/core';
import {animate, state, style, transition, trigger} from "@angular/animations";
import {ActivatedRoute, Params} from "@angular/router";
import {NgbNavChangeEvent} from '@ng-bootstrap/ng-bootstrap';
import {AbstractComponent} from "@components";
import {Country, Discount, Lookups, Organiser, OrganiserPaymentData, UserDetail} from "@model";
import {AuthenticationService, Features, OrganiserService, Permission, PermissionService} from "@services";

@Component({
  selector: 'app-organiser-details',
  templateUrl: './organiser-details.component.html',
  styleUrls: ['./organiser-details.component.scss'],
  animations: [
    trigger('fadeInAnimation', [
      state('in', style({opacity: 1})),
      transition(':enter', [
        style({opacity: 0}),
        animate(1600)
      ])
    ])]
})
export class OrganiserDetailsComponent extends AbstractComponent {
  @Input() languages: Lookups[] = [];
  @Input() countries: Country[] = [];
  @Input() listOfDiscounts: Discount[] = [];
  @Input() users: UserDetail[] | undefined;
  @Input() currencies: Lookups[] = [];
  @Input() paymentData: OrganiserPaymentData | undefined;
  @Input() categoryTypes: Lookups[] = [];

  organiserFormMode: OrganiserFormMode | undefined;
  currentOrganiser: Organiser | undefined;
  selectedNavIndex:number = 1;

  constructor(
    private organiserService: OrganiserService, private permissionService: PermissionService,
    private route: ActivatedRoute, public authenticationService: AuthenticationService) {
    super();
  }

  ngOnInit(): void {
    if (this.route.snapshot.routeConfig?.path === "profile") {
      this.organiserFormMode = OrganiserFormMode.PROFILE;
    } else {
      this.organiserFormMode = OrganiserFormMode.NEW;
    }
    this.subscribeToChangeOrganiser();
    this.subscribeToQueryParamsChange();
  }

  private subscribeToChangeOrganiser() {
    this.subscriptions.push(this.organiserService.currentOrganiser.subscribe((value: Organiser | undefined) => {
      if (value) {
        this.currentOrganiser = value;
      }
    }));
    this.subscriptions.push(this.organiserService.loggedInOrganiser.subscribe((value: Organiser | undefined) => {
      if (value) {
        this.currentOrganiser = value;
      }
    }));
  }

  private subscribeToQueryParamsChange() {
    let organiserId: Params = this.route.snapshot.queryParams['organiserId'];
    return this.route.queryParams.subscribe(_ => {
      if (this.organiserFormMode === OrganiserFormMode.PROFILE) {
        this.organiserService.getLoggedInOrganiser();
      } else {
        if (this.currentOrganiser?.id !== this.route.snapshot.queryParams['organiserId']) {
          this.organiserService.getOrganiser(+organiserId);
          this.organiserFormMode = OrganiserFormMode.EDIT;
        }
        if (!organiserId) {
          this.organiserFormMode = OrganiserFormMode.NEW;
          this.currentOrganiser = new Organiser();
        }
      }
    });
  }

  onNavChange(changeEvent: NgbNavChangeEvent): void {
    this.selectedNavIndex = changeEvent.nextId;
  }

  paymentDataChanged(paymentData: OrganiserPaymentData) {
    this.paymentData = paymentData;
  }


  checkPermission(listItem: string): boolean {
    switch (listItem) {
      case 'CATEGORIES_TAB':
        return this.permissionService.checkPermission(Features.CategoriesTab, Permission.Edit);
      case 'DISCOUNTS_TAB':
        return this.permissionService.checkPermission(Features.DiscountsTab, Permission.Edit);
      default:
        return false;
    }
  }

  onDiscountsChanged(listOfDiscounts: Discount[]) {
    this.listOfDiscounts = listOfDiscounts;
  }

  onUsersChange(users: UserDetail[] | undefined) {
    this.users = users;
  }

  override ngOnDestroy(): void {
    super.ngOnDestroy();
    this.organiserService.currentOrganiser.next(undefined);
  }
}

export enum OrganiserFormMode {
  EDIT,
  NEW,
  PROFILE
}

